import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import { fiatWalletRoutes } from '../fiatWallet'
import { cryptoWalletRoutes } from '../cryptoWallet'

const walletShellRoutes: RouteRecordRaw[] = [
  {
    path: routes.WALLET,
    name: 'WALLET',
    component: () => import('./WalletPage.vue'),
    meta: { requiresAuth: true, title: 'Wallet' },
  },
]

export const walletRoutes: RouteRecordRaw[] = [
  ...walletShellRoutes,
  ...fiatWalletRoutes,
  ...cryptoWalletRoutes,
]
